import { render, staticRenderFns } from "./admissionNotification.vue?vue&type=template&id=44f86105"
import script from "./admissionNotification.vue?vue&type=script&lang=js"
export * from "./admissionNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports